const DEFAULT_HOST_BRAND_OPENIDKEY = 'share_skb'

const BRAND_HOSTS = [
  {
    brandKey: 'skb',
    url: 'share.shikaobang.cn',
    openidK: 'share_skb',
    openidBrandkey: 'skb',
  },
  {
    brandKey: 'skb',
    url: 'share.test.shikaobang.cn',
    openidK: 'share_skb_test',
    openidBrandkey: 'skb',
  },
  {
    brandKey: 'jbcgk',
    url: 'share.jbcgk.com',
    openidK: 'share_jbcgk',
    openidBrandkey: 'jbcgk',
  },
  {
    brandKey: 'jbcgk',
    url: 'share.test.jbcgk.com',
    openidK: 'share_jbcgk_test',
    openidBrandkey: 'jbcgk',
  },
  {
    brandKey: 'gpjs',
    url: 'share.guopeichina.com',
    openidK: 'share_gpjiaoshi',
    openidBrandkey: 'gpjiaoshi',
  },
  {
    brandKey: 'gpjs',
    url: 'share.test.guopeichina.com',
    openidK: 'share_gpjiaoshi_test',
    openidBrandkey: 'gpjiaoshi',
  },
  {
    brandKey: 'gpjs',
    url: 'share.jbcjiaoshi.com',
    openidK: 'share_gpjs',
    openidBrandkey: 'gpjiaoshi',
  },
  {
    brandKey: 'gpjs',
    url: 'share.test.jbcjiaoshi.com',
    openidK: 'share_gpjs_test',
    openidBrandkey: 'gpjiaoshi',
  },
  {
    brandKey: 'xuandiao',
    url: 'share.xuandiaobang.com',
    openidK: 'share_xuandiao',
    openidBrandkey: 'xuandiao',
  },
  {
    brandKey: 'xuandiao',
    url: 'share.test.xuandiaobang.com',
    openidK: 'share_xuandiao_test',
    openidBrandkey: 'xuandiao',
  },
  {
    brandKey: 'jbczsb',
    url: 'share.jbczsb.com',
    openidK: 'share_jbczsb',
    openidBrandkey: 'jbczsb',
  },
  {
    brandKey: 'jbczsb',
    url: 'share.test.jbczsb.com',
    openidK: 'share_jbczsb_test',
    openidBrandkey: 'jbczsb',
  },
  {
    brandKey: 'jbcyk',
    url: 'share.yianjiaoyu.com',
    openidK: 'share_jbcyk',
    openidBrandkey: 'jbcyk',
  },
  {
    brandKey: 'jbcyk',
    url: 'share.test.yianjiaoyu.com',
    openidK: 'share_jbcyk_test',
    openidBrandkey: 'jbcyk',
  },
  {
    brandKey: 'jbcshangan',
    url: 'share.jbcshangan.com',
    openidK: 'share_jbcshangan',
    openidBrandkey: 'jbcshangan',
  },
  {
    brandKey: 'jbcshangan',
    url: 'share.test.jbcshangan.com',
    openidK: 'share_jbcshangan_test',
    openidBrandkey: 'jbcshangan',
  },
]

const BRANDS = [
  {
    name: '事考帮',
    brandKey: 'skb',
    schema: {
      protocal: 'skb',
      failUrl: 'cn.net.tiku.shikaobang.syn',
    },
    imageLogoURL:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/skb/logo.png',
    imageGoodsLocal:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/skb/goods/local.png',
    imageGoodsTitleButtonDownLoad:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/skb/goods/title_button_download.png',
    imageGoodsTitleButtonQQ:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/skb/goods/title_button_qq.png',
    imageGoodsTitleButtonText:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/skb/goods/title_button_text.png',
    imageGoodsCourseSeriesXuanke:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/skb/goods/xuanke.png',
    imageGoodsCourseSelect:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/skb/goods/select.png',
    imageEstimateReportMarkPoint:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/common/webview/forecast_score/report/images/mark_point_skb.png',
  },
  {
    name: '金标尺公考',
    brandKey: 'jbcgk',
    schema: {
      protocal: 'jbcgk',
      failUrl: 'cn.net.tiku.jbcgk.syn',
    },
    imageLogoURL:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcgk/logo.png',
    imageGoodsLocal:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcgk/goods/local.png',
    imageGoodsTitleButtonDownLoad:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcgk/goods/title_button_download.png',
    imageGoodsTitleButtonQQ:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcgk/goods/title_button_qq.png',
    imageGoodsTitleButtonText:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcgk/goods/title_button_text.png',
    imageGoodsCourseSeriesXuanke:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcgk/goods/xuanke.png',
    imageGoodsCourseSelect:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcgk/goods/select.png',
    imageEstimateReportMarkPoint:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/common/webview/forecast_score/report/images/mark_point_jbcgk.png',
  },
  {
    name: '金标尺教师',
    brandKey: 'gpjs',
    schema: {
      protocal: 'gpjs',
      failUrl: 'cn.net.tiku.gpjiaoshi.syn',
    },
    imageLogoURL:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/gpjs/logo.png',
    imageGoodsLocal:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/gpjs/goods/local.png',
    imageGoodsTitleButtonDownLoad:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/gpjs/goods/title_button_download.png',
    imageGoodsTitleButtonQQ:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/gpjs/goods/title_button_qq.png',
    imageGoodsTitleButtonText:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/gpjs/goods/title_button_text.png',
    imageGoodsCourseSeriesXuanke:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/gpjs/goods/xuanke.png',
    imageGoodsCourseSelect:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/gpjs/goods/select.png',
    imageEstimateReportMarkPoint:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/common/webview/forecast_score/report/images/mark_point_jbcgk.png',
  },
  {
    name: '选调帮',
    brandKey: 'xuandiao',
    schema: {
      protocal: 'xuandiao',
      failUrl: 'cn.net.tiku.gongkao.xuandiao',
    },
    imageLogoURL:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/xuandiao/logo.png',
    imageGoodsLocal:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/xuandiao/goods/local.png',
    imageGoodsTitleButtonDownLoad:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/xuandiao/goods/title_button_download.png',
    imageGoodsTitleButtonQQ:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/xuandiao/goods/title_button_qq.png',
    imageGoodsTitleButtonText:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/xuandiao/goods/title_button_text.png',
    imageGoodsCourseSeriesXuanke:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/xuandiao/goods/xuanke.png',
    imageGoodsCourseSelect:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/xuandiao/goods/select.png',
    imageEstimateReportMarkPoint:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/common/webview/forecast_score/report/images/mark_point_jbcgk.png',
  },
  {
    name: '金标尺专升本',
    brandKey: 'jbczsb',
    schema: {
      protocal: 'jbczsb',
      failUrl: 'cn.tiku.android.zsb',
    },
    imageLogoURL:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbczsb/logo.png',
    imageGoodsLocal:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbczsb/goods/local.png',
    imageGoodsTitleButtonDownLoad:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbczsb/goods/title_button_download.png',
    imageGoodsTitleButtonQQ:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbczsb/goods/title_button_qq.png',
    imageGoodsTitleButtonText:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbczsb/goods/title_button_text.png',
    imageGoodsCourseSeriesXuanke:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbczsb/goods/xuanke.png',
    imageGoodsCourseSelect:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbczsb/goods/select.png',
    imageEstimateReportMarkPoint:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/common/webview/forecast_score/report/images/mark_point_jbczsb.png',
  },
  {
    name: '医岸',
    brandKey: 'jbcyk',
    schema: {
      protocal: 'jbcyk',
      failUrl: 'com.tiku.android.yian',
    },
    imageLogoURL:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcyk/logo.png',
    imageGoodsLocal:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcyk/goods/local.png',
    imageGoodsTitleButtonDownLoad:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcyk/goods/title_button_download.png',
    imageGoodsTitleButtonQQ:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcyk/goods/title_button_qq.png',
    imageGoodsTitleButtonText:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcyk/goods/title_button_text.png',
    imageGoodsCourseSeriesXuanke:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcyk/goods/xuanke.png',
    imageGoodsCourseSelect:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcyk/goods/select.png',
    imageEstimateReportMarkPoint:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/common/webview/forecast_score/report/images/mark_point_jbcyk.png',
  },
  {
    name: '金标尺上岸',
    brandKey: 'jbcshangan',
    schema: {
      protocal: 'jbcshangan',
      failUrl: 'com.tiku.android.shangan',
    },
    imageLogoURL:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcshangan/logo.png',
    imageGoodsLocal:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcshangan/goods/local.png',
    imageGoodsTitleButtonDownLoad:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcshangan/goods/title_button_download.png',
    imageGoodsTitleButtonQQ:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcshangan/goods/title_button_qq.png',
    imageGoodsTitleButtonText:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcshangan/goods/title_button_text.png',
    imageGoodsCourseSeriesXuanke:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcshangan/goods/xuanke.png',
    imageGoodsCourseSelect:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/skb/wv/share/images/jbcshangan/goods/select.png',
    imageEstimateReportMarkPoint:
      'https://appresource-1253756937.cos.ap-chengdu.myqcloud.com/common/webview/forecast_score/report/images/mark_point_jbcshangan.png',
  },
]

function getGpjsSchemaProtocal() {
  let isIOS = !(
    navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
  ) //android终端
  return isIOS ? 'gpjiaoshi' : 'gpjs'
}

const CURRENT_HOST_BRAND = getCurrentHostBrand(BRAND_HOSTS, DEFAULT_HOST_BRAND_OPENIDKEY)
const CURRENT_BRAND = getCurrentBrand(CURRENT_HOST_BRAND.brandKey)

// 获取访问品牌信息
function getCurrentHostBrand(list, defaultHostBrandOpenidkey) {
  const hostURL = window.location.host
  let result = list.filter((brand) => {
    const brandURL = brand.url

    if (Object.prototype.toString.call(brandURL) === '[object Array]') {
      return brandURL.filter((url) => url === hostURL).length >= 1
    }
    if (Object.prototype.toString.call(brandURL) === '[object String]') {
      return brandURL === hostURL
    }
  })

  if (result.length === 0) {
    result = list.filter((brand) => {
      return brand.openidK === defaultHostBrandOpenidkey
    })
  }

  return result[0] || list[0]
}

// 获取openid url 地址
function getWxOpenidURL(query = {}) {
  query.brandkey = CURRENT_HOST_BRAND.openidBrandkey
  let p = JSON.stringify(query)

  // 测试服调用另一个地址
  // if (CURRENT_HOST_BRAND.openidK.indexOf('test') >= 0) {
  // 	return `https://wxapi.shikaobang.cn/third-auth/web/wx/getOpenid?k=${CURRENT_HOST_BRAND.openidK}&p=${p}`
  // }

  return `https://wxapi.shikaobang.cn/third-auth/web/wx/getOpenid?k=${CURRENT_HOST_BRAND.openidK}&p=${p}`
}

function getCurrentBrand(brandKey) {
  return BRANDS.filter((brand) => {
    return brand.brandKey === brandKey
  })[0]
}

function getCurrentBrandSchemaParam() {
  return JSON.parse(JSON.stringify(CURRENT_BRAND.schema))
}

module.exports = {
  getWxOpenidURL,
  getCurrentBrand: CURRENT_BRAND,
  getCurrentBrandSchemaParam: getCurrentBrandSchemaParam(),
}
